import { inject } from 'vue';
import { externalEventSeriesKey } from '../keys';

export function useExternalEventSeriesInjection() {
    const externalEventSeriesInjection = inject(externalEventSeriesKey);
    if (!externalEventSeriesInjection) {
        throw new Error('External event series not properly injected');
    }
    return externalEventSeriesInjection;
}
